import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type UserProfileInfo, type UserInfo } from './UserInfo'

const initialState: UserInfo = {
  profileInfo: {
    email: '',
    firstName: '',
    lastName: '',
    userRole: '',
    userRoleLevel: 0,
    dealerShip: '',
    region: '',
    locale: '',
    organizationName: '',
  },
}

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    reset: () => initialState,
    setUserProfileInfo: (
      state,
      { payload }: PayloadAction<UserProfileInfo>
    ) => {
      state.profileInfo = payload
    },
  },
})

export const { reset, setUserProfileInfo } = userInfoSlice.actions
export default userInfoSlice.reducer
